export default __webpack_public_path__ + "static/charliehead-448107f4994065cd5a42164ac0ff1125.png";